<template>
  <Layout tituloPagina="Sistema | Ajustes | Corte de servicio">
    <div class="card shadow-sm">
      <div class="card-header justify-content-between d-flex align-items-center border-bottom">
        <div>
          <h4 class="card-title mb-1 d-flex align-items-center">
            <i class="mdi mdi-account-cancel-outline text-danger me-2 font-size-22"></i>
            Corte de Servicio
          </h4>
          <p class="text-muted mb-0 font-size-13">
            Configuración y programación de las reglas automáticas para el corte de servicios.
          </p>
        </div>
        <div>
          <div class="dropdown">
            <a
              class="dropdown-toggle"
              href="javascript: void(0);"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <eva-icon
                name="more-horizontal-outline"
                data-eva-width="20"
                data-eva-height="20"
                :class="{
                  'fill-dark': $store.state.layout.layoutMode == 'light',
                  'fill-white': $store.state.layout.layoutMode == 'dark'
                }"
              ></eva-icon>
            </a>
            <ul class="dropdown-menu dropdown-menu-end shadow">
              <li>
                <a
                  href="#"
                  class="dropdown-item"
                  onclick="return false"
                  @click="actualizar()"
                  v-if="!bandera_spinner"
                >
                  <i class="mdi mdi-content-save text-success me-1"></i>
                  Actualizar
                </a>
                <span class="dropdown-item disabled" v-if="bandera_spinner">
                  <i class="mdi mdi-loading mdi-spin me-1"></i>
                  Actualizando...
                </span>
              </li>
              <li>
                <a
                  class="dropdown-item" href="#"
                  onclick="return false;" @click="$router.go(-1)"
                >
                  <i class="mdi mdi-close text-secondary me-1"></i>
                  Cerrar
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card-body p-4">
        <!-- Spinner de carga inicial -->
        <div v-if="cargando_ajustes" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="text-muted mt-2">Cargando configuración...</p>
        </div>

        <div v-else>
          <!-- Sección 1: Programación de fecha y hora -->
          <div class="mb-4">
            <h5 class="text-primary font-size-15 mb-3 d-flex align-items-center">
              <i class="mdi mdi-clock-outline me-2 font-size-18"></i>
              Programación de Ejecución
            </h5>
            
            <div class="row g-3">
              <!-- Día de corte -->
              <div class="col-md-3">
                <label class="form-label font-weight-bold">
                  Día de corte
                  <i class="mdi mdi-help-circle-outline text-muted" title="Día del mes en que se ejecutará el corte de servicio"></i>
                </label>
                <div class="input-group">
                  <span class="input-group-text bg-light text-muted">
                    <i class="mdi mdi-calendar-month-outline"></i>
                  </span>
                  <input
                    type="number"
                    min="1"
                    max="31"
                    class="form-control text-end"
                    v-model.number="ajustes.dias_despues_corte_servicios"
                    placeholder="1"
                    onkeypress="return check(event, 'enteros')"
                  />
                  <span class="input-group-text bg-light">
                    del mes
                  </span>
                </div>
                <small class="form-text text-muted">
                  Día del mes programado para procesar cortes.
                </small>
              </div>

              <!-- Hora de corte -->
              <div class="col-md-3">
                <label class="form-label font-weight-bold">
                  Hora de corte
                  <i class="mdi mdi-help-circle-outline text-muted" title="Hora del día en que comenzará el proceso"></i>
                </label>
                <div class="input-group">
                  <span class="input-group-text bg-light text-muted">
                    <i class="mdi mdi-clock-outline"></i>
                  </span>
                  <input
                    ref="horaCorteServicio"
                    type="time"
                    step="1"
                    class="form-control text-center"
                    v-model="ajustes.hora_corte_servicios"
                    placeholder="HH:mm:ss"
                  />
                  <span class="input-group-text bg-light">
                    Hrs.
                  </span>
                </div>
                <small class="form-text text-muted">
                  Hora exacta en formato 24 hrs.
                </small>
              </div>

              <!-- Días de la semana para corte -->
              <div class="col-md-6">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <label class="form-label font-weight-bold mb-0">
                    Días de la semana permitidos
                  </label>
                  <!-- Botones de selección rápida -->
                  <div class="btn-group btn-group-sm d-none d-sm-inline-flex" role="group">
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-xs py-0 px-2 font-size-11"
                      @click="seleccionarTodosDias"
                      title="Seleccionar los 7 días de la semana"
                    >
                      Todos
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-xs py-0 px-2 font-size-11"
                      @click="seleccionarDiasLaborales"
                      title="Seleccionar de Lunes a Viernes"
                    >
                      Lun - Vie
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-xs py-0 px-2 font-size-11"
                      @click="seleccionarFinSemana"
                      title="Seleccionar Sábado y Domingo"
                    >
                      Sáb - Dom
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-xs py-0 px-2 font-size-11"
                      @click="limpiarDias"
                      title="Limpiar selección"
                    >
                      Limpiar
                    </button>
                  </div>
                </div>
                <multiselect
                  v-model="ajustes.dias_semana_cortes"
                  placeholder="Selecciona los días permitidos"
                  selectLabel="Enter para seleccionar"
                  selectedLabel="Seleccionado"
                  deselectLabel="Enter para eliminar"
                  label="nombre"
                  track-by="dia"
                  :options="opciones_dias_semana_corte"
                  :multiple="true"
                  :taggable="false"
                  :close-on-select="false"
                  :clear-on-select="false"
                >
                  <template #noResult>
                    <span class="text-muted">No se encontraron días.</span>
                  </template>
                </multiselect>
                <small class="form-text text-muted">
                  El corte solo se aplicará si la fecha coincide con los días seleccionados.
                </small>
              </div>
            </div>
          </div>

          <hr class="my-4 text-muted opacity-25">

          <!-- Sección 2: Condiciones de saldo -->
          <div class="mb-4">
            <h5 class="text-primary font-size-15 mb-3 d-flex align-items-center">
              <i class="mdi mdi-cash-multiple me-2 font-size-18"></i>
              Condiciones de Saldo y Tolerancia
            </h5>
            
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label font-weight-bold">
                  Umbral de saldo para corte
                  <i class="mdi mdi-help-circle-outline text-muted" title="Monto mínimo adeudado para considerar al cliente elegible para corte"></i>
                </label>
                <div class="input-group">
                  <span class="input-group-text bg-light text-muted">
                    {{ monedaSistema.simbolo || '$' }}
                  </span>
                  <input
                    ref="umbralCorteSaldo"
                    type="number"
                    step="0.01"
                    min="0"
                    class="form-control text-end font-weight-bold"
                    v-model.number="ajustes.umbral_corte_por_saldo"
                    placeholder="0.00"
                  />
                  <span class="input-group-text bg-light">
                    {{ monedaSistema.codigo || 'MXN' }}
                  </span>
                </div>
                <small class="form-text text-muted">
                  Monto adeudado a partir del cual se aplicará el corte (0 para cortar con cualquier saldo pendiente).
                </small>
              </div>
            </div>
          </div>

          <!-- Sección 3: Resumen y Estado de la regla -->
          <div class="card border border-primary-subtle bg-soft-primary rounded-3 mt-4 mb-0">
            <div class="card-body py-3 px-4">
              <div class="d-flex align-items-center">
                <div class="avatar-sm me-3 flex-shrink-0">
                  <span class="avatar-title bg-primary text-white rounded-circle font-size-18">
                    <i class="mdi mdi-information-variant"></i>
                  </span>
                </div>
                <div class="flex-grow-1">
                  <h6 class="font-size-14 text-primary mb-1 font-weight-bold">
                    Resumen de la política de corte
                  </h6>
                  <p class="font-size-13 text-secondary mb-2">
                    Los cortes automáticos se procesarán los días
                    <strong :class="$store.state.layout.layoutMode == 'dark' ? 'text-white' : 'text-dark'">
                      {{ ajustes.dias_despues_corte_servicios || 1 }} de cada mes
                    </strong>
                    a las
                    <strong :class="$store.state.layout.layoutMode == 'dark' ? 'text-white' : 'text-dark'">
                      {{ ajustes.hora_corte_servicios || '00:00:00' }} hrs
                    </strong>,
                    siempre que el día corresponda a
                    <strong :class="$store.state.layout.layoutMode == 'dark' ? 'text-white' : 'text-dark'">
                      {{ diasSeleccionadosTexto }}
                    </strong>
                    y el cliente mantenga un saldo vencido superior a
                    <strong class="text-danger">
                      {{ monedaSistema.simbolo || '$' }}{{ formatearMonto(ajustes.umbral_corte_por_saldo) }} {{ monedaSistema.codigo || 'MXN' }}
                    </strong>.
                  </p>

                  <!-- Advertencia si no hay días seleccionados -->
                  <div
                    v-if="!ajustes.dias_semana_cortes || ajustes.dias_semana_cortes.length === 0"
                    class="alert alert-warning py-1 px-2 font-size-12 mb-0 d-inline-flex align-items-center"
                  >
                    <i class="mdi mdi-alert-outline me-1 font-size-14"></i>
                    Atención: No se ha seleccionado ningún día de la semana. Los cortes automáticos no se ejecutarán.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Botones de Acción -->
    <div class="text-right">
      <div class="btn-group">
        <button 
          class="btn btn-secondary px-3"
          @click="$router.go(-1)"
        >
          <i class="mdi mdi-chevron-left me-1"></i>
          Atras
        </button>
        <button 
          class="btn btn-success px-4" 
          @click="actualizar()" 
          :disabled="bandera_spinner || cargando_ajustes"
        >
          <i
            class="mdi"
            :class="!bandera_spinner ? 'mdi-content-save' : 'mdi-concourse-ci mdi-spin'"
          ></i>
          {{ bandera_spinner ? 'Guardando...' : 'Actualizar' }}
        </button>
      </div>
    </div>
    <br>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main"
import SistemaSrv from '@/services/SistemaSrv.js'
import Multiselect from 'vue-multiselect'

export default {
  name: 'CorteServicio',
  components: { Layout, Multiselect },
  data: function() {
    return {
      ajustes: {
        dias_despues_corte_servicios: 1,
        hora_corte_servicios: "00:00:00",
        dias_semana_cortes: [],
        umbral_corte_por_saldo: 0
      },
      opciones_dias_semana_corte: [
        { dia: 'Mon', nombre: 'Lunes' },
        { dia: 'Tue', nombre: 'Martes' },
        { dia: 'Wed', nombre: 'Miércoles' },
        { dia: 'Thu', nombre: 'Jueves' },
        { dia: 'Fri', nombre: 'Viernes' },
        { dia: 'Sat', nombre: 'Sábado' },
        { dia: 'Sun', nombre: 'Domingo' },
      ],
      ordenDiasSemana: [
        'Mon', 'Tue', 'Wed', 'Thu', 
        'Fri', 'Sat', 'Sun'
      ],
      bandera_spinner: false,
      cargando_ajustes: false
    }
  },
  computed: {
    monedaSistema() {
      return this.$store.state.todo?.moneda_sistema || { simbolo: '$', codigo: 'MXN' }
    },
    diasSeleccionadosTexto() {
      if (!this.ajustes.dias_semana_cortes || this.ajustes.dias_semana_cortes.length === 0) {
        return 'ningún día'
      }
      if (this.ajustes.dias_semana_cortes.length === 7) {
        return 'todos los días de la semana'
      }
      return this.ajustes.dias_semana_cortes.map(d => d.nombre).join(', ')
    }
  },
  created: function(){
    this.refrescarAjustes()
  },
  watch: {
    'ajustes.dias_semana_cortes': {
      handler(nuevoValor) {
        if (!Array.isArray(nuevoValor)) return
        const ordenado = [...nuevoValor].sort((a, b) =>
          this.ordenDiasSemana.indexOf(a.dia) -
          this.ordenDiasSemana.indexOf(b.dia)
        )

        // Comparación para evitar loops infinitos
        if (JSON.stringify(ordenado) !== JSON.stringify(nuevoValor)) {
          this.ajustes.dias_semana_cortes = ordenado
        }
      },
      deep: true
    }
  },
  methods: {
    seleccionarTodosDias() {
      this.ajustes.dias_semana_cortes = [...this.opciones_dias_semana_corte]
    },
    
    seleccionarDiasLaborales() {
      this.ajustes.dias_semana_cortes = this.opciones_dias_semana_corte.filter(d => 
        ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(d.dia)
      )
    },

    seleccionarFinSemana() {
      this.ajustes.dias_semana_cortes = this.opciones_dias_semana_corte.filter(d => 
        ['Sat', 'Sun'].includes(d.dia)
      )
    },

    limpiarDias() {
      this.ajustes.dias_semana_cortes = []
    },

    formatearMonto(monto) {
      const num = Number(monto) || 0
      return num.toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },

    validarFormulario() {
      const dia = Number(this.ajustes.dias_despues_corte_servicios)
      if (isNaN(dia) || dia < 1 || dia > 31) {
        iu.msg.error('Por favor indique un día de corte válido (entre 1 y 31).')
        return false
      }
      if (!this.ajustes.hora_corte_servicios) {
        iu.msg.error('Por favor especifique la hora de corte.')
        return false
      }
      if (Number(this.ajustes.umbral_corte_por_saldo) < 0) {
        iu.msg.error('El umbral de saldo no puede ser un valor negativo.')
        return false
      }
      return true
    },

    actualizar() {
      if (!this.validarFormulario()) return

      let self = this
      let ajustes = Object.assign({}, self.ajustes)

      self.bandera_spinner = true

      SistemaSrv.actualizar(ajustes).then(() => {
        iu.msg.success('Los datos de corte del servicio se han actualizado correctamente.')
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No fue posible actualizar los datos de corte del servicio.'
        iu.msg.error(mensaje)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },

    refrescarAjustes() {
      let self = this
      let ajustesSolicitados = Object.keys(self.ajustes)

      self.cargando_ajustes = true

      SistemaSrv.ajustes(ajustesSolicitados).then(response => {
        let ajustes = response.data || {}
        Object.assign(self.ajustes, ajustes)

        try {
          self.ajustes.dias_semana_cortes = JSON.parse(ajustes.dias_semana_cortes)
        } catch(e) {
          self.ajustes.dias_semana_cortes = []
        }
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No fue posible obtener la configuración de los cortes de servicio.'
        iu.msg.error(mensaje)
      }).finally(() => {
        self.cargando_ajustes = false
      })
    }
  }
}
</script>

<style scoped>
.btn-xs {
  font-size: 0.75rem;
  padding: 0.15rem 0.4rem;
  border-radius: 0.2rem;
}

.bg-soft-primary {
  background-color: rgba(85, 110, 230, 0.08) !important;
}

.border-primary-subtle {
  border-color: rgba(85, 110, 230, 0.25) !important;
}

.avatar-sm {
  height: 2rem;
  width: 2rem;
}

.avatar-title {
  align-items: center;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}
</style>